import _ from "lodash";
import {returnButton, saveButton} from "../utils";

export const presentButton = nextStatus => ({
    action: 'present',
    type: 'action',
    nextStatus,
    //nextStatus: 'readyToBePresented',
    tKey: 'Présenter',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
})

export const adjourn = {
    action: 'adjourn',
    type: 'action',
    nextStatus: 'incomplete',
    tKey: 'Ajourne',
    bsStyle: 'warning',
    bypassFormValidation: true,
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}


export const validateButton = {
    action: 'validate',
    type: 'action',
    nextStatus: 'validated',
    tKey: 'Accepte',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}

export const rejectButton = {
    action: 'reject',
    type: 'action',
    nextStatus: 'rejected',
    tKey: 'Renonce',
    bsStyle: 'danger',
    bypassFormValidation: true,
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}

export const prepareListButton = {
    type: 'action',
    action: 'prepareList',
    tKey: 'Préparer la liste',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}

export const generateReportButton = {
    type: 'action',
    action: 'generateReport',
    tKey: 'Générer et envoyer le relevé de décisions',
    bsStyle: 'primary',
    getUserConfirmation: true,
    confirmationMessage: 'validationConfirmationMessage',
}

export const getButtonsForModule = (file, context) => {
    const statusId = _.get(file, 'status.id')
    const { moduleId } = context.clientContext

    if( moduleId === 'm-C-liberalityFile') {
        if(statusId === 'draft') return [presentButton('readyToBePresented'), saveButton, returnButton]
        if(statusId === 'incomplete') return [presentButton('updated'), saveButton, returnButton]
    }

    if( moduleId === 'm-C-liberalityFileDecision') {
        if(statusId === 'awaitingDecision') return [validateButton, rejectButton, adjourn, saveButton, returnButton]
    }

    return [returnButton]
}

export function calculateNetForecast({
                                  typeOfFileId,
                                  distribution = [],
                                  grossAssets = 0,
                                  grossLiabilities = 0,
                                  actsFees = 0,
                                  assets = 0
                              }) {
    // Calculate totals
    const totalSharePercentage = distribution.reduce((total, { share = 0 }) => total + (share / 100), 0);
    const totalOwnLiabilities = distribution.reduce((total, { ownLiabilities = 0 }) => total + ownLiabilities, 0);

    let result;
    // Perform calculation based on type
    switch (typeOfFileId) {
        case 'legs':
            result = (grossAssets - grossLiabilities - actsFees) * totalSharePercentage - totalOwnLiabilities;
            break;
        case 'lifeInsurance':
            result = assets * totalSharePercentage;
            break;
        case 'donations':
        case 'giftsOnInheritance':
            result = (grossAssets - actsFees) * totalSharePercentage;
            break;
        default:
            result = 0;
    }

    return result
}

export function getFieldsByPath(fieldsArray, paths) {
    return fieldsArray.reduce((acc, field) => {
        if (paths.includes(field.path)) {
            acc[field.path] = field;
        }
        return acc;
    }, {});
}
